/* CHAOS Moto scroll-scrub engine v1.2
   Canvas frame-sequence scrubber. Modes:
   - pin (default): section taller than viewport, sticky inner; progress = scroll through the pin.
   - transit (data-scrub-mode="transit"): no pin; progress = section's travel across the viewport. */
(function () {
  'use strict';
  if (window.__chaosScrubLoaded) return;
  window.__chaosScrubLoaded = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ChaosScrub(el) {
    this.el = el;
    this.canvas = el.querySelector('.chaos-scrub__canvas');
    var json = el.querySelector('script[data-scrub-frames]');
    if (!this.canvas || !json) return;
    try { this.urls = JSON.parse(json.textContent); } catch (e) { return; }
    this.count = this.urls.length;
    if (!this.count) return;
    this.mode = el.getAttribute('data-scrub-mode') || 'pin';
    this.ctx = this.canvas.getContext('2d');
    this.frames = new Array(this.count);
    this.current = -1;
    this.shown = 0;
    this.raf = null;
    this.init();
  }

  ChaosScrub.prototype.load = function (i) {
    var self = this;
    if (this.frames[i]) return Promise.resolve(this.frames[i]);
    return new Promise(function (res, rej) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { self.frames[i] = img; res(img); };
      img.onerror = rej;
      img.src = self.urls[i];
    });
  };

  ChaosScrub.prototype.init = function () {
    var self = this;
    this.load(0).then(function () {
      self.draw(0);
      self.el.classList.add('is-on');
      if (REDUCED) return;
      self.preloadAll();
      self.bind();
    }).catch(function () {});
  };

  ChaosScrub.prototype.preloadAll = function () {
    var order = [], seen = {}, i, step;
    for (step = 8; step >= 1; step = step >> 1) {
      for (i = 0; i < this.count; i += step) {
        if (!seen[i]) { seen[i] = 1; order.push(i); }
      }
    }
    var self = this, idx = 0, inflight = 0, MAX = 6;
    (function pump() {
      while (inflight < MAX && idx < order.length) {
        inflight++;
        self.load(order[idx++]).catch(function () {}).then(function () {
          inflight--; pump();
        });
      }
    })();
  };

  ChaosScrub.prototype.progress = function () {
    var rect = this.el.getBoundingClientRect();
    if (this.mode === 'transit') {
      var vh = window.innerHeight;
      var p2 = (vh - rect.top) / (vh + rect.height);
      return Math.max(0, Math.min(1, p2));
    }
    var scrollable = rect.height - window.innerHeight;
    if (scrollable <= 0) return 0;
    var p = -rect.top / scrollable;
    return Math.max(0, Math.min(1, p));
  };

  ChaosScrub.prototype.draw = function (i) {
    var img = this.frames[i];
    if (!img) {
      for (var d = 1; d < this.count; d++) {
        if (this.frames[i - d]) { img = this.frames[i - d]; break; }
        if (this.frames[i + d]) { img = this.frames[i + d]; break; }
      }
    }
    if (!img) return;
    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
    this.current = i;
  };

  ChaosScrub.prototype.tick = function () {
    var self = this;
    var target = this.progress() * (this.count - 1);
    this.shown += (target - this.shown) * 0.35;
    if (Math.abs(target - this.shown) < 0.5) this.shown = target;
    var i = Math.round(this.shown);
    if (i !== this.current) this.draw(i);
    this.raf = requestAnimationFrame(function () { self.tick(); });
  };

  ChaosScrub.prototype.bind = function () {
    var self = this;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!self.raf) self.tick();
        } else if (self.raf) {
          cancelAnimationFrame(self.raf); self.raf = null;
        }
      });
    }, { rootMargin: '20% 0px' });
    io.observe(this.el);
  };

  function boot() {
    var els = document.querySelectorAll('.chaos-scrub');
    for (var i = 0; i < els.length; i++) new ChaosScrub(els[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
